import { Button } from "@nextui-org/button";
import { Tooltip } from "@nextui-org/tooltip";
import { Undo2, XCircle } from "lucide-react";
import { useTranslations } from 'next-intl';
import React from 'react';

interface BrushControlsProps {
  brushSize: number;
  setBrushSize: (size: number) => void;
  handleUndo: () => void;
  handleClearAll: () => void;
  isImageLoaded: boolean;
  lines: any[]; // 这里可能需要更具体的类型定义，取决于lines的实际结构
}

export const BrushControls: React.FC<BrushControlsProps> =  ({
  brushSize,
  setBrushSize,
  handleUndo,
  handleClearAll,
  isImageLoaded,
  lines
}) => {
  const t = useTranslations()
  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      <div className="flex items-center space-x-2">
        <Tooltip content={t('BrushControls.adjustBrushSize')}>
          <input
            type="range"
            title={t('BrushControls.brushSize')}
            min="1"
            max="50"
            value={brushSize}
            onChange={(e) => setBrushSize(Number(e.target.value))}
            className="w-32"
            disabled={!isImageLoaded}
          />
        </Tooltip>
        <span>{brushSize}</span>
      </div>
      <div className="flex space-x-2">
        <Tooltip content={t('BrushControls.undoLastStep')}>
          <Button
            isIconOnly
            onClick={handleUndo}
            disabled={!isImageLoaded || lines.length === 0}
            aria-label={t('BrushControls.undo')}
          >
            <Undo2 />
          </Button>
        </Tooltip>
        <Tooltip content={t('BrushControls.clearAllBrushes')}>
          <Button
            isIconOnly
            onClick={handleClearAll}
            disabled={!isImageLoaded || lines.length === 0}
            aria-label={t('BrushControls.clearAllBrushes')}
          >
            <XCircle />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};